// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-radio-button ~ .mat-radio-button {
  margin-left: 16px;
}

.civil-id-photos > div,
.rc-book-photos > div,
.car-photos > div {
  margin-bottom: 20px;
}

.purchase-detail .questions {
  margin-top: 20px;
}
.purchase-detail .questions mat-label {
  font-size: 12px;
}

.mat-form-field {
  width: 100%;
}

form small.error {
  position: relative;
  top: -24px;
}

.downloadPDF {
  background-color: #efefef;
}

.car-photo-label {
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 10px;
  margin-top: 20px;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNyLWRldGFpbC5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsaUJBQWlCO0FBQ25COztBQUVBOzs7RUFHRSxtQkFBbUI7QUFDckI7O0FBRUE7RUFDRSxnQkFBZ0I7QUFDbEI7QUFDQTtFQUNFLGVBQWU7QUFDakI7O0FBRUE7RUFDRSxXQUFXO0FBQ2I7O0FBRUE7RUFDRSxrQkFBa0I7RUFDbEIsVUFBVTtBQUNaOztBQUVBO0VBQ0UseUJBQXlCO0FBQzNCOztBQUVBO0VBQ0UsZUFBZTtFQUNmLGdCQUFnQjtFQUNoQixtQkFBbUI7RUFDbkIsZ0JBQWdCO0FBQ2xCIiwiZmlsZSI6ImNyLWRldGFpbC5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLm1hdC1yYWRpby1idXR0b24gfiAubWF0LXJhZGlvLWJ1dHRvbiB7XG4gIG1hcmdpbi1sZWZ0OiAxNnB4O1xufVxuXG4uY2l2aWwtaWQtcGhvdG9zID4gZGl2LFxuLnJjLWJvb2stcGhvdG9zID4gZGl2LFxuLmNhci1waG90b3MgPiBkaXYge1xuICBtYXJnaW4tYm90dG9tOiAyMHB4O1xufVxuXG4ucHVyY2hhc2UtZGV0YWlsIC5xdWVzdGlvbnMge1xuICBtYXJnaW4tdG9wOiAyMHB4O1xufVxuLnB1cmNoYXNlLWRldGFpbCAucXVlc3Rpb25zIG1hdC1sYWJlbCB7XG4gIGZvbnQtc2l6ZTogMTJweDtcbn1cblxuLm1hdC1mb3JtLWZpZWxkIHtcbiAgd2lkdGg6IDEwMCU7XG59XG5cbmZvcm0gc21hbGwuZXJyb3Ige1xuICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gIHRvcDogLTI0cHg7XG59XG5cbi5kb3dubG9hZFBERiB7XG4gIGJhY2tncm91bmQtY29sb3I6ICNlZmVmZWY7XG59XG5cbi5jYXItcGhvdG8tbGFiZWwge1xuICBmb250LXNpemU6IDEycHg7XG4gIGZvbnQtd2VpZ2h0OiA2MDA7XG4gIG1hcmdpbi1ib3R0b206IDEwcHg7XG4gIG1hcmdpbi10b3A6IDIwcHg7XG59XG4iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/secure/cr-detail/cr-detail.component.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,wvCAAwvC","sourcesContent":[".mat-radio-button ~ .mat-radio-button {\n  margin-left: 16px;\n}\n\n.civil-id-photos > div,\n.rc-book-photos > div,\n.car-photos > div {\n  margin-bottom: 20px;\n}\n\n.purchase-detail .questions {\n  margin-top: 20px;\n}\n.purchase-detail .questions mat-label {\n  font-size: 12px;\n}\n\n.mat-form-field {\n  width: 100%;\n}\n\nform small.error {\n  position: relative;\n  top: -24px;\n}\n\n.downloadPDF {\n  background-color: #efefef;\n}\n\n.car-photo-label {\n  font-size: 12px;\n  font-weight: 600;\n  margin-bottom: 10px;\n  margin-top: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
